var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-1"},[_c('span',{class:`text-${_vm.cor}`},[_c('i',{class:`fa ${_vm.icone} fa-lg icon-button`,attrs:{"title":_vm.titulo},on:{"click":function($event){$event.stopPropagation();return _vm.exibirEventoseConsultorias()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }